import { Stack, useBreakpointValue } from '@chakra-ui/react';

import AssignmentCardSlider from '../components/assignments/AssignmentCardSlider';
import LearnerDashboardOverviewBrowseTabs from '../components/browse-learn-grow/LearnerDashboardOverviewBrowseTabs';
import LearnerDashboardOverviewContentContainer from '../components/overview/LearnerDashboardOverviewContentContainer';
import LearnerDashboardOverviewHero from '../components/overview/LearnerDashboardOverviewHero';
import { useGetDashboardUserAssignments } from '@/client/components/learners/dashboard/hooks/useGetUserAssignments';
import { useLearnerDashboardStore } from '../learnerDashboardStore';
import { useTranslation } from 'react-i18next';

export default function LearnerDashboardOverview() {
  const { t } = useTranslation();
  const { data } = useGetDashboardUserAssignments();
  const { selectedOverviewTabId } = useLearnerDashboardStore();

  const isMobile = useBreakpointValue({ base: true, md: false });

  const browseLinkMap: Record<string, { label: string; route: string }> = {
    'recently-viewed': {
      label: isMobile
        ? t('learners.dashboard.showAll')
        : t('learners.dashboard.overview.showAllRecentlyViewed'),
      route: 'recently-viewed',
    },
    bookmarks: {
      label: isMobile
        ? t('learners.dashboard.showAll')
        : t('learners.dashboard.overview.showAllBookmarks'),
      route: 'bookmarks',
    },
    'for-you': {
      label: isMobile
        ? t('learners.dashboard.showAll')
        : t('learners.dashboard.overview.showAllForYou'),
      route: 'recommendations',
    },
  };

  return (
    <Stack spacing={12}>
      {!isMobile && <LearnerDashboardOverviewHero />}

      <LearnerDashboardOverviewContentContainer
        title={
          data
            ? isMobile
              ? t('learners.dashboard.overview.assignmentCount.mobile', {
                  count: data.openAssignments.length,
                })
              : t('learners.dashboard.overview.assignmentCount', {
                  count: data.openAssignments.length,
                })
            : t('learners.dashboard.overview.openAssignments')
        }
        link={{
          label: isMobile
            ? t('learners.dashboard.showAll')
            : t('learners.dashboard.overview.showAllAssignments'),
          route: 'assignments',
        }}
      >
        <AssignmentCardSlider />
      </LearnerDashboardOverviewContentContainer>

      <LearnerDashboardOverviewContentContainer
        title={t('learners.dashboard.overview.browseLearnGrow')}
        link={{
          label: browseLinkMap[selectedOverviewTabId].label,
          route: browseLinkMap[selectedOverviewTabId].route,
        }}
      >
        <LearnerDashboardOverviewBrowseTabs />
      </LearnerDashboardOverviewContentContainer>
    </Stack>
  );
}
